import { isShadowRoot as a } from "./instanceOf.js";
function f(r, e) {
  var t = e.getRootNode && e.getRootNode();
  if (r.contains(e))
    return !0;
  if (t && a(t)) {
    var o = e;
    do {
      if (o && r.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
export {
  f as default
};
